export default __webpack_public_path__ + "static/media/top100-logo.0b79537c.png";